import { FONT_FAMILY_VARIANTS } from '@/components/Typography/constants.js';
import { Heading } from '@/components/Typography/Heading.js';
import { Smallcaps } from '@/components/Typography/Smallcaps.js';
import { styled } from '@/stitches/index.js';

export const StyledSmallcaps = styled(Smallcaps, {
  fontSize: '$18',
  fontWeight: 500,
  letterSpacing: '$1',
});

export const Container = styled('div', {
  padding: '$24 0',
  position: 'relative',
  width: '100%',
});

export const DetailsContainer = styled('div', {
  alignItems: 'end',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
});

export const PricingContainer = styled('div', {
  '& > *': {
    letterSpacing: '$1_5',
  },
  alignItems: 'start',
  display: 'flex',
  flexDirection: 'column',
});

export const Title = styled(Heading, {
  '@bp0': {
    fontSize: '$28',
  },
  '@bp2': {
    fontSize: '$48',
  },
  fontFamily: '$heading',
  fontWeight: '$medium',
  letterSpacing: 0,
  margin: 0,
  marginBottom: '$16',
  variants: {
    fontFamily: {
      ...FONT_FAMILY_VARIANTS,
      generalSans: {
        fontWeight: '$semiBold',
      },
      panchang: {
        '@bp0': {
          fontSize: '$20',
        },
        '@bp2': {
          fontSize: '$32',
        },
        '@bp4': {
          fontSize: '$40',
        },
      },
      switzer: {
        fontWeight: '$medium',
      },
      syne: {
        fontWeight: '$medium',
      },
      zodiak: {
        fontWeight: '$regular',
      },
    },
  },
});
